/**
 * Minimal Altair chart effect - extracted from legacy altairEffects.ts
 * This is the only function still needed from the legacy file.
 */
import { RefObject, useEffect } from "react";
import vegaEmbed from "vega-embed";

interface UseAltairChartEffectParams {
    embedRef: RefObject<HTMLDivElement>;
    jsonString: string;
}

export const useAltairChartEffect = ({
    embedRef,
    jsonString,
}: UseAltairChartEffectParams) => {
    useEffect(() => {
        if (embedRef.current && jsonString) {
            try {
                vegaEmbed(embedRef.current, JSON.parse(jsonString));
            } catch (err) {
                console.error("❌ [Ameen] Error rendering Altair chart:", err);
            }
        }
    }, [embedRef, jsonString]);
};
